import validate from "/usr/src/app/content/n3-treatments-29a00db6-8423-4187-b4dc-bff4b2abb885/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-29a00db6-8423-4187-b4dc-bff4b2abb885/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}